module.exports = __webpack_public_path__ + "static/media/vegitables_59.43f89c3f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_59.csv
// module id = 645
// module chunks = 0